import HTTP from '@/plugins/axios';

export const analysis = async(params: any) => {
  try {
    await HTTP.get('/portal/statistics', {
      params,
    });
  } catch (error: any) {
    // eslint-disable-next-line no-console
    console.error(error.message);
    throw error;
  }
};
